import type { Blueprint } from '../../base/blueprints/Blueprint';
import type { ValidationErrors } from '../../base/types/ValidationErrors';
import type { ProcessCallback } from '../types/ProcessCallback';
import type { FormBuilderContract } from '..';
import type { Entry } from './Entry';
import { instanceOfEntry } from './Entry';

export abstract class ValidEntry<TData> implements Entry
{
    public abstract type: string;
    public abstract data: TData;
    public errors: ValidationErrors;

    public abstract collect(blueprint: Blueprint, builder: FormBuilderContract, preprocess: ProcessCallback): Promise<Entry>;
    public abstract validate(blueprint: Blueprint, builder: FormBuilderContract): boolean;

    public constructor()
    {
        this.errors = {};
    }

    public valid(): boolean
    {
        return Object.keys(this.errors).length == 0;
    }

    public errorMessage(name: string): string
    {
        return name in this.errors && this.errors[name].length > 0 ? this.errors[name][0] : null;
    }

    public clearErrors()
    {
        this.errors = {};
    }
}

export const instanceOfValidEntry = (object: any): object is ValidEntry<any> =>
{
    return instanceOfEntry(object) && 'validate' in object && typeof object.validate === 'function';
};
